export default __webpack_public_path__ + "static/media/check.151f53b2.svg";